import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HotTable } from '@handsontable/react-wrapper';
import '../styles/cf-template.css';
import { Divider, TextField, Typography } from '@mui/material';
import useCashFlowHandsonTableConfig from '@modules/cashflow/cf-template/hooks/useCashFlowHandsonTableConfig';
import useCRUDCashflowTemplateController from '@modules/cashflow/cf-template/controllers/crud-cf-template.controller';
import { cashflowTemplateData } from '@modules/cashflow/cf-template/models/data';
import HeaderCFTemplate from '@modules/cashflow/cf-template/components/HeaderCFTemplate';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var CreateCashFlowTemplate = function () {
    var _a = useCRUDCashflowTemplateController(), hotRef = _a.hotRef, listBtns = _a.listBtns, amountIndex = _a.amountIndex, titleInputRef = _a.titleInputRef, requiredColumns = _a.requiredColumns, handleCheckRequiredColumns = _a.handleCheckRequiredColumns, handleCheckRequiredColumnsAfterDrop = _a.handleCheckRequiredColumnsAfterDrop;
    var t = useCustomTranslation();
    var _b = useCashFlowHandsonTableConfig({
        handleCheckRequiredColumnsAfterDrop: handleCheckRequiredColumnsAfterDrop
    }), colWidths = _b.colWidths, contextMenu = _b.contextMenu, cellValidator = _b.cellValidator, generateMergeCells = _b.generateMergeCells;
    var _c = generateMergeCells(cashflowTemplateData), mergeCells = _c.mergeCells, highlightedRows = _c.highlightedRows;
    var cells = function (row, col) {
        var cellProperties = {};
        if (row !== 0 || col < 3) {
            cellProperties.editor = false;
        }
        else {
            cellProperties.validator = cellValidator;
            cellProperties.allowInvalid = true;
            // cellProperties.manualColumnMove = true
        }
        if (highlightedRows.has(row) && col >= 1) {
            cellProperties.className = 'parent-row';
        }
        return cellProperties;
    };
    return (_jsxs("div", { className: 'table_handsome ht-theme-main flex flex-col gap-2 overflow-y-auto p-8', children: [_jsx(HeaderCFTemplate, { title: t('L000111'), listBtns: listBtns }), _jsxs("div", { className: 'flex-1 flex flex-col gap-2 pb-3 bg-white rounded-lg', children: [_jsxs("div", { className: 'flex w-full px-4 py-2 items-center gap-3', children: [_jsx(Typography, { children: t('L000027') }), _jsx(TextField, { inputRef: titleInputRef, variant: 'standard', required: true, sx: {
                                    width: 200
                                } })] }), _jsx(Divider, { sx: {
                            height: 2
                        } }), _jsx(Typography, { variant: 'h5', sx: {
                            px: 2
                        }, children: "Content Frame" }), _jsx("div", { className: 'px-4 flex-1', children: _jsx(HotTable, { ref: hotRef, width: '100%', height: '100%', data: cashflowTemplateData, contextMenu: contextMenu('create'), cells: cells, comments: true, colWidths: colWidths, selectionMode: 'single', mergeCells: mergeCells, afterChange: function (changes, source) {
                                if (source === 'edit') {
                                    var hotInstance_1 = hotRef.current.hotInstance;
                                    changes.forEach(function (_a) {
                                        var row = _a[0], col = _a[1];
                                        hotInstance_1.setCellMeta(row, Number(col), 'comment', null);
                                    });
                                    hotInstance_1.render();
                                }
                            }, colHeaders: function (col) {
                                var defaultColumns = ['Seq. Col', 'Item Column', 'Department'];
                                var title = defaultColumns[col] || "Required";
                                if (col === amountIndex) {
                                    return '<span>Amt. Column</span>';
                                }
                                if (col < defaultColumns.length) {
                                    return "<span>".concat(title, "</span>");
                                }
                                return "\n              <div style=\"display: flex; justify-content: space-between; align-items: center; gap: 5px; cursor: pointer\">\n                <input type=\"checkbox\" ".concat(requiredColumns[col] ? 'checked' : '', " data-col=\"").concat(col, "\" />\n                <span>").concat(title, "</span>\n              </div>\n            ");
                            }, afterGetColHeader: function (col, TH) {
                                var checkbox = TH.querySelector("input[type=\"checkbox\"][data-col=\"".concat(col, "\"]"));
                                if (checkbox) {
                                    checkbox.addEventListener('change', function (e) {
                                        handleCheckRequiredColumns(e, col);
                                    });
                                }
                            }, licenseKey: 'non-commercial-and-evaluation' }) })] })] }));
};
export default CreateCashFlowTemplate;
